/* eslint-disable max-lines-per-function */
import React, { useState, useRef } from 'react';
import { Form, Field } from 'formik';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import MidiaService from '../../../../services/tvs/midiaServices';
import { mostrarMensagemErro } from '../../shared/getMensagens';
import { ProgressSpinner } from 'primereact/progressspinner';

export function FormCadastrarMidia(
    { setRecarregarDataTable, setMensagem,
        nomebotao, setOpenModalCadastro, rowSelecionada }) {
    const zero = 0;
    const mensagemToast = useRef(null);    
    const [validarArquivo, setValidarArquivo] = useState(false);
    const [dados, setDados] = useState();
    const [loand, setLoand] = useState(false);

    const condicaoPrincipal = nomebotao === 'Atualizar';

    const erroFile = () => {
        mensagemToast.current.show({ severity: 'error',
            summary: 'Tipo de arquivo invalido',
            detail: 'tipos permitidos; imagem.png, imagem.jpg, imagem.jpeg e video.mp4',
            life:'5000' });
    };

    const fileValidation = event => {
        const arrValidation = [ 'image/png', 'image/jpg', 'image/jpeg', 'video/mp4'];
        
        return arrValidation.includes(event.target.files[zero].type) ? true : false;
    };
   
    const onFileChange = event => {
        const validadte = fileValidation(event);        

        setDados(event.target.files[zero]);
        setValidarArquivo(validadte);

        if(!validadte) {
            erroFile();
        } else {
            return false;
        }

        return false;
    };

    const onChangeMidiaPost = async event => {
        event.preventDefault();

        const descricao = event.target.descricao.value;
       
        try {
            setLoand(true);
            await MidiaService.adicionarMidia(descricao, dados);
            
            setLoand(false);
            setMensagem(true);
            setOpenModalCadastro(false);
            setRecarregarDataTable(true);
        } catch (error) {
            mostrarMensagemErro(mensagemToast,'Erro ao cadastrar midia.');
            setLoand(false);
            throw new Error(error);
        }
    };

    const onChangeMidiaPut = async event => {
        event.preventDefault();

        const descricao = event.target.descricao.value;

        try {
            setLoand(true);
            await MidiaService.atualizarMidia(descricao, dados, rowSelecionada.Id_doc);
            
            setLoand(false);
            setMensagem(true);
            setRecarregarDataTable(true);
            setOpenModalCadastro(false);
        } catch (error) {
            mostrarMensagemErro(mensagemToast,'Erro ao atualizar midia.');
            setLoand(false);
            throw new Error(error);
        }
    };

    const onSubmitFunction = e => {
        condicaoPrincipal ? onChangeMidiaPut(e) : onChangeMidiaPost(e);

        return false;
    };
 
    return (
        <div className="p-grid p-fluid">
            <Growl ref={mensagemToast}/>  
            {loand ? <div className="p-col size-spinner">  <ProgressSpinner /></div>  :         
                <Form 
                    onSubmit={onSubmitFunction}
                    style={{ fontWeight: 'bold' }}
                >                                     
                    <div className="p-grid p-fluid">               
                        <div className="p-col-12 p-md-12">                   
                            <div className="form-item-label">
                                <label htmlFor="estado">{nomebotao}</label><br />
                                <input                            
                                    onChange={ e => onFileChange(e)}
                                    required={condicaoPrincipal ? false : true}
                                    type="file"
                                    name="files"
                                    id="fileUpload"
                                    accept='image/png, image/jpg, image/jpeg, video/mp4' />                    
                                                                                      
                            </div>
                        </div>
                    </div>
                
                    <div  className="p-grid p-fluid">
                        <div className="p-col-12 p-md-12">
                            <div className="form-item-label">
                                <label htmlFor="descricao">Descrição</label>  
                                <Field
                                    required
                                    as={InputText}
                                    id="descricao"
                                    name="descricao"
                                    type="text"
                                    size={30}
                                    maxLength={60}
                                />
                            
                            </div>
                        </div>
                    </div> 
                    <div  className="p-grid p-fluid">
                        <div className="p-col-6 p-md-6">  
                            <Button
                                label={nomebotao} 
                                disabled={nomebotao !== 'Atualizar' && !validarArquivo}
                                type="submit"></Button>
                        </div>
                    </div>
                </Form>
            }
        </div>
    );
}